import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";

// Космический фон с анимированными звездами
export const SpaceBackground = styled(Box)(() => ({
    position: 'relative',
    minHeight: '100vh',
    // background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 50%, #3730a3 100%)',
    background: 'linear-gradient(110deg, rgba(59, 190, 219, 1) 20%, rgba(238, 234, 252, 1) 112%, rgba(227, 247, 250, 1) 100%)',
    overflow: 'hidden',
    '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundImage: `
            radial-gradient(2px 2px at 20px 30px, #eee, transparent),
            radial-gradient(2px 2px at 40px 70px, #fff, transparent),
            radial-gradient(1px 1px at 90px 40px, #fff, transparent),
            radial-gradient(1px 1px at 130px 80px, #fff, transparent),
            radial-gradient(2px 2px at 160px 30px, #ddd, transparent)
        `,
        backgroundRepeat: 'repeat',
        backgroundSize: '200px 100px',
        animation: 'starMove1 20s linear infinite',
        zIndex: 1,
    },
    '&::after': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundImage: `
            radial-gradient(1px 1px at 40px 60px, #fff, transparent),
            radial-gradient(1px 1px at 120px 50px, #fff, transparent),
            radial-gradient(1px 1px at 170px 80px, #fff, transparent),
            radial-gradient(2px 2px at 10px 20px, #fff, transparent),
            radial-gradient(1px 1px at 80px 90px, #fff, transparent)
        `,
        backgroundRepeat: 'repeat',
        backgroundSize: '300px 150px',
        animation: 'starMove2 10s linear infinite',
        zIndex: 1,
    },
    '@keyframes starMove1': {
        from: {
            transform: 'translateZ(0px)',
        },
        to: {
            transform: 'translateZ(1000px)',
        },
    },
    '@keyframes starMove2': {
        from: {
            transform: 'translateZ(0px)',
        },
        to: {
            transform: 'translateZ(1000px)',
        },
    },
}));

// Эффект туманности
export const NebulaEffect = styled(Box)(() => ({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: `
        radial-gradient(ellipse at 20% 50%, rgba(59, 190, 219, 0.2) 0%, transparent 50%),
        radial-gradient(ellipse at 80% 20%, rgba(34, 211, 238, 0.15) 0%, transparent 50%),
        radial-gradient(ellipse at 40% 80%, rgba(6, 182, 212, 0.25) 0%, transparent 50%)
    `,
    animation: 'nebulaDrift 30s ease-in-out infinite',
    zIndex: 2,
    '@keyframes nebulaDrift': {
        '0%, 100%': {
            transform: 'translateX(0) translateY(0) rotate(0deg)',
            opacity: 0.7,
        },
        '25%': {
            transform: 'translateX(-20px) translateY(-10px) rotate(1deg)',
            opacity: 0.8,
        },
        '50%': {
            transform: 'translateX(20px) translateY(20px) rotate(-1deg)',
            opacity: 0.6,
        },
        '75%': {
            transform: 'translateX(10px) translateY(-20px) rotate(0.5deg)',
            opacity: 0.9,
        },
    },
}));

// Основной контейнер с космическим стилем
export const Wrapper = styled(Box)(() => ({
    display: "flex",
    alignItems: "center",
    justifyContent: 'center',
    flexDirection: 'column',
    position: 'relative',
    zIndex: 10,
    minHeight: '100vh',
}));

// Стеклянная карточка для формы
export const GlassCard = styled(Box)(() => ({
    background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.2) 0%, rgba(6, 182, 212, 0.2) 100%)',
    backdropFilter: 'blur(16px)',
    border: '1px solid rgba(59, 130, 246, 0.3)',
    borderRadius: '16px',
    padding: '32px',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
    width: '100%',
    maxWidth: '400px',
}));

// Поле логина с космическим стилем
export const StyledLoginField = styled(TextField)(() => ({
    marginTop: '24px',
    width: '100%',
    '& .MuiOutlinedInput-root': {
        backgroundColor: 'rgba(30, 41, 59, 0.5)',
        color: 'white',
        borderRadius: '8px',
        '& fieldset': {
            borderColor: 'rgba(59, 130, 246, 0.3)',
        },
        '&:hover fieldset': {
            borderColor: 'rgba(59, 130, 246, 0.5)',
        },
        '&.Mui-focused fieldset': {
            borderColor: '#E3F7FA ',
        },
    },
    '& .MuiInputLabel-root': {
        color: '#E3F7FA ',
        '&.Mui-focused': {
            color: '#E3F7FA ',
        },
    },
    '& .MuiInputBase-input::placeholder': {
        color: 'rgba(147, 197, 253, 0.5)',
        opacity: 1,
    },
    '& .MuiInputBase-input': {
        '&:-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 1000px rgba(30, 41, 59, 0.5) inset !important',
            WebkitTextFillColor: 'white !important',
            transition: 'background-color 5000s ease-in-out 0s',
        },
        '&:-webkit-autofill:hover': {
            WebkitBoxShadow: '0 0 0 1000px rgba(30, 41, 59, 0.5) inset !important',
            WebkitTextFillColor: 'white !important',
        },
        '&:-webkit-autofill:focus': {
            WebkitBoxShadow: '0 0 0 1000px rgba(30, 41, 59, 0.5) inset !important',
            WebkitTextFillColor: 'white !important',
        },
        '&:-webkit-autofill:active': {
            WebkitBoxShadow: '0 0 0 1000px rgba(30, 41, 59, 0.5) inset !important',
            WebkitTextFillColor: 'white !important',
        },
    },
}));

// Поле пароля с космическим стилем
export const StyledPasswordField = styled(FormControl)(() => ({
    marginTop: '24px',
    width: '100%',
    '& .MuiOutlinedInput-root': {
        backgroundColor: 'rgba(30, 41, 59, 0.5)',
        color: 'white',
        borderRadius: '8px',
        '& fieldset': {
            borderColor: 'rgba(59, 130, 246, 0.3)',
        },
        '&:hover fieldset': {
            borderColor: 'rgba(59, 130, 246, 0.5)',
        },
        '&.Mui-focused fieldset': {
            borderColor: '#E3F7FA ',
        },
    },
    '& .MuiInputLabel-root': {
        color: '#E3F7FA ',
        '&.Mui-focused': {
            color: '#E3F7FA ',
        },
    },
    '& .MuiInputBase-input::placeholder': {
        color: 'rgba(147, 197, 253, 0.5)',
        opacity: 1,
    },
    '& .MuiInputBase-input': {
        '&:-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 1000px rgba(30, 41, 59, 0.5) inset !important',
            WebkitTextFillColor: 'white !important',
            transition: 'background-color 5000s ease-in-out 0s',
        },
        '&:-webkit-autofill:hover': {
            WebkitBoxShadow: '0 0 0 1000px rgba(30, 41, 59, 0.5) inset !important',
            WebkitTextFillColor: 'white !important',
        },
        '&:-webkit-autofill:focus': {
            WebkitBoxShadow: '0 0 0 1000px rgba(30, 41, 59, 0.5) inset !important',
            WebkitTextFillColor: 'white !important',
        },
        '&:-webkit-autofill:active': {
            WebkitBoxShadow: '0 0 0 1000px rgba(30, 41, 59, 0.5) inset !important',
            WebkitTextFillColor: 'white !important',
        },
    },
}));

// Кнопка с космическим стилем
export const StyledButton = styled(Button)(() => ({
    marginTop: '24px',
    width: '100%',
    height: '48px',
    background: 'linear-gradient(135deg, #3b82f6 0%, #06b6d4 100%)',
    color: 'white',
    fontWeight: 600,
    fontSize: '16px',
    borderRadius: '8px',
    textTransform: 'none',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
        background: 'linear-gradient(135deg, #2563eb 0%, #0891b2 100%)',
        transform: 'translateY(-2px) scale(1.02)',
        boxShadow: '0 8px 25px rgba(59, 130, 246, 0.4)',
    },
    '&:active': {
        transform: 'translateY(0) scale(1)',
    },
    '&:disabled': {
        background: 'rgba(59, 130, 246, 0.3)',
        color: 'rgba(255, 255, 255, 0.5)',
        transform: 'none',
        boxShadow: 'none',
    },
}));

// Заголовок с эффектом свечения
export const GlowingTitle = styled(Box)(() => ({
    textAlign: 'center',
    marginBottom: '32px',
    '& h1': {
        fontSize: '48px',
        fontWeight: 'bold',
        color: 'white',
        margin: '0 0 16px 0',
        textShadow: `
            0 0 10px rgba(59, 130, 246, 0.5),
            0 0 20px rgba(59, 130, 246, 0.3),
            0 0 30px rgba(59, 130, 246, 0.2)
        `,
        animation: 'titleGlow 3s ease-in-out infinite',
    },
    '& p': {
        color: '#E3F7FA ',
        fontSize: '14px',
        margin: 0,
        lineHeight: 1.5,
    },
    '@keyframes titleGlow': {
        '0%, 100%': {
            textShadow: `
                0 0 10px rgba(59, 130, 246, 0.5),
                0 0 20px rgba(59, 130, 246, 0.3),
                0 0 30px rgba(59, 130, 246, 0.2)
            `,
        },
        '50%': {
            textShadow: `
                0 0 15px rgba(59, 130, 246, 0.8),
                0 0 25px rgba(59, 130, 246, 0.5),
                0 0 35px rgba(59, 130, 246, 0.3)
            `,
        },
    },
}));

// Логотип с космическим эффектом
export const SpaceLogo = styled(Box)(() => ({
    fontSize: '64px',
    marginBottom: '16px',
    animation: 'logoFloat 4s ease-in-out infinite',
    '@keyframes logoFloat': {
        '0%, 100%': {
            transform: 'translateY(0px) rotate(0deg)',
        },
        '50%': {
            transform: 'translateY(-10px) rotate(5deg)',
        },
    },
}));